var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "550mm",
    height: 2357.392,
    viewBox: "0 0 550 623.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m-1449.852 505.813-42.65-478.287h468.576l-42.703 478.208-191.876 53.181z",
    style: {
      fill: "#1572b6",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1258.214 518.275 155.046-42.995 36.46-408.649h-191.506z",
    style: {
      fill: "#33a9dc",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1258.214 239.907h77.628l5.345-60.06h-82.973v-58.632h147.108l-1.402 15.743-14.42 161.66h-131.286z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1257.897 392.254h-.264l-65.326-17.648-4.18-46.778h-58.844l8.229 92.101 120.174 33.444h.343v-61.119z",
    style: {
      fill: "#ebebeb",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1185.56 296.052-7.064 78.501-65.431 17.648v61.119l120.253-33.338.873-9.922 10.213-114.035h-58.844z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1258.003 121.215v58.658h-141.658l-1.217-13.176-2.672-29.74-1.402-15.742zm-.211 118.692v58.658h-64.585l-1.138-13.176-2.672-29.74-1.402-15.742h69.77z",
    style: {
      fill: "#ebebeb",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.17377 0 0 1.17377 1751.85 -32.309)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.734ee8b6102ad06d65eb87c0c6506af3.svg";
export { ForwardRef as ReactComponent };